import { render, staticRenderFns } from "./RoleDetail.vue?vue&type=template&id=213b2d85&scoped=true&"
import script from "./RoleDetail.vue?vue&type=script&lang=js&"
export * from "./RoleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b2d85",
  null
  
)

export default component.exports